module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAaCAYAAABozQZiAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABgSURBVDiN7dJBCoAwDETRwYvZo+VmPdp3IUjRFqbRjdBZ901KiDQZIDgTWQhAGtq4B4GSgTUNs1+1YV1wDO9bDQtK2iTt7uPe5MIz9vTR7f6s4PUOVsFHBbXVNm5KroIDwLX3osjJkvkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left.png
// module id = F0Yv
// module chunks = 0